import moment from "moment";
import {AUTH_ACTION, CALL_LOG_ACTION} from "../action-types";
import {IDataTableRef} from "../../components";
import {FilterModel} from "../../utils/types";
import {CallRecordModel} from "../../utils/types";

export interface ICallLogState {
  filters: FilterModel[];
  logs: CallRecordModel[];
  selectedLogs: CallRecordModel[];
  tableRef?: IDataTableRef;
}

const defaultRangeFilter = (): FilterModel => ({
  category: 'range',
  text: 'Last 7 Days',
  value: {
    startDate: moment().subtract(7, 'days').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
});

const initialState: ICallLogState = {
  filters: [],
  logs: [],
  selectedLogs: [],
};

const callLogReducer = (state: ICallLogState = initialState, action: any) => {
  switch (action.type) {
    case CALL_LOG_ACTION.INIT_FILTERS: {
      if (state.filters.some((item) => item.category === 'range')) {
        return state;
      }
      return {
        ...state,
        filters: [defaultRangeFilter(), ...state.filters],
      };
    }

    case CALL_LOG_ACTION.SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };

    case CALL_LOG_ACTION.ADD_FILTERS: {
      let newFilters = state.filters.filter((item) => (
        action.filters.every((f) => f.category !== item.category)
      ));
      newFilters = newFilters.concat(action.filters);
      return {
        ...state,
        filters: newFilters,
      };
    }

    case CALL_LOG_ACTION.SET_LOGS:
      return {
        ...state,
        logs: action.logs,
      };

    case CALL_LOG_ACTION.SET_SELECTED_LOGS:
      return {
        ...state,
        selectedLogs: action.selectedLogs,
      };

    case CALL_LOG_ACTION.SET_TABLE_REF:
      return {
        ...state,
        tableRef: action.tableRef,
      };

    // Filters, rows and selections all belong to the previous organization.
    case AUTH_ACTION.ORG_CONTEXT_CHANGED:
      return initialState;

    default:
      return state;
  }
};

export default callLogReducer;
